import { DatePicker, RangePickerProps } from 'components/DatePicker';
import FormItem from 'antd/lib/form/FormItem';
import { useRef } from 'react';
import { useTranslate } from '@tolgee/react';
import { useMemoizedFn } from 'ahooks';
import dayjs, { Dayjs } from 'lib/dayjs';

interface OrderDateFormFieldProps {
  form: any;
  disabled?: boolean;
  disabledDate?: RangePickerProps['disabledDate'];
}

export const TradeDateFormField = (props: OrderDateFormFieldProps) => {
  const { form, disabled, disabledDate } = props;
  const { t } = useTranslate();
  const dateRangeRef = useRef<[Dayjs, Dayjs]>();

  const handleDatePickerOpenChange = useMemoizedFn((visible) => {
    const dateRange = form.getFieldValue('tradeDateRange');

    if (visible) {
      dateRangeRef.current = dateRange;

      form.setFieldsValue({
        tradeDateRange: undefined,
      });
    } else {
      if (!dateRange) {
        form.setFieldsValue({
          tradeDateRange: dateRangeRef.current,
        });
      }
    }
  });
  const handleDatePickerChange = useMemoizedFn((dates) => {
    form.setFieldsValue({ tradeDateRange: dates ?? [] });
  });
  const disableDate = useMemoizedFn((current: Dayjs) => {
    const dates = form.getFieldValue('tradeDateRange');
    const bigThanToday = current.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days') > 0;
    if (!dates) {
      return bigThanToday;
    }
    const tooLate = dates[0] && current.diff(dates[0], 'days') > 13;
    const tooEarly = dates[1] && dates[1].diff(current, 'days') > 13;
    return !!tooEarly || !!tooLate || bigThanToday;
  });

  return (
    <FormItem label={t('订单日期')} name="tradeDateRange">
      <DatePicker.RangePicker
        disabled={disabled}
        allowClear={false}
        onCalendarChange={handleDatePickerChange}
        onChange={handleDatePickerChange}
        onOpenChange={handleDatePickerOpenChange}
        disabledDate={disabledDate || disableDate}
      />
    </FormItem>
  );
};
